/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    GROWTH_FUND_LEVEL_TITLE: {
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_LEVEL_TITLE_REACHED: {
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_LEVEL_REWARD: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    GROWTH_FUND_LEVEL_REWARD_REACHED: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.GREEN,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_LEVEL_VALUE: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    GROWTH_FUND_LEVEL_VALUE_REACHED: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.GREEN,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_CTA2: {
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    GROWTH_FUND_CTA1: {
        color: cleverapps.styles.COLORS.YELLOW,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    GROWTH_FUND_RECEIVE_AMOUNT: {
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.overrideStyles(cleverapps.styles.GrowthFundWindow, {
    margin: 0,

    window: {
        padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }
    },

    top: {
        width: 1000,
        height: 290,

        text: {
            anchor: { x: 0.5, y: 0.5 },
            x: { align: "center", dx: 165 },
            y: { align: "center", dy: 30 }
        },

        icon: {
            x: { align: "center", dx: -135 },
            y: { align: "center", dy: -10 }
        },

        button: {
            x: { align: "right", dx: -53 },
            y: { align: "bottom", dy: 17 }
        },

        mark: {
            x: { align: "right", dx: -140 },
            y: { align: "bottom", dy: 20 }
        }
    },

    scroll: {
        margin: 0,
        width: 1000,
        height: 710,

        top: undefined
    }
});

cleverapps.overrideStyles(cleverapps.styles.GrowthFundLevelView, {
    width: 1000,
    height: 200,

    iconBg: {
        x: { align: "left", dx: 0 },
        y: { align: "center", dy: 0 },
        width: 260,
        height: 200
    },

    title: {
        x: { align: "left", dx: 295 },
        y: { align: "center", dy: 25 }
    },

    icon: {
        x: { align: "left", dx: 55 },
        y: { align: "center", dy: 0 }
    },

    rewards: {
        x: { align: "left", dx: 295 },
        y: { align: "center", dy: -25 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.GrowthFundBuyWindow, {
    badge: {
        x: { align: "right", dx: 40 },
        y: { align: "top", dy: -100 }
    }
});
